import { customizedPlacement } from "./customizedStructure";
import { portraitPlacement } from "./portraitStructure";
import { landscapePlacement } from "./landscapeStructure";
import { singleCarportPlacement } from "./singleCarportPlacement";
import { doubleCarportPlacement } from "./doubleCarportPlacement";
import { panelInformation } from "../../../DataFiles/panelInformation";
import { handleSmith } from "./smithStructure";

export const handleStructureClick = ({
  structureItem,
  rowDistance,
  roofInfo,
  dispatch,
  abstacles,
  gridInfo,
  roofDetail,
  quantityInfo,
  designParameter,
}) => {
  let limitCapacity = 0;
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );
  const structureWatt = panel.pMax;
  if (roofDetail.customCapacity !== 0 && designParameter.customCapacityCheck) {
    limitCapacity = (
      roofDetail.customCapacity /
      (structureItem.structureWatt * (structureWatt / 1000))
    ).toFixed();
  }

  if (
    structureItem.name === "Smith Pro P" ||
    structureItem.name === "Smith Through Rail P"
  ) {
    portraitPlacement({
      roofInfo,
      structureItem,
      dispatch,
      abstacles,
      gridInfo,
      limitCapacity,
      quantityInfo,
      roofDetail,
    });
  } else if (
    structureItem.name === "Smith Pro L" ||
    structureItem.name === "Smith Through Rail L"
  ) {
    landscapePlacement({
      roofInfo,
      structureItem,
      dispatch,
      abstacles,
      gridInfo,
      limitCapacity,
      quantityInfo,
      roofDetail,
    });
  } else if (structureItem.name === "Customized") {
    customizedPlacement({
      roofInfo,
      structureItem,
      dispatch,
      abstacles,
      gridInfo,
      limitCapacity,
      quantityInfo,
      roofDetail,
    });
  } else if (structureItem.name === "Single Carport") {
    singleCarportPlacement({
      roofInfo,
      structureItem,
      dispatch,
      abstacles,
      gridInfo,
      limitCapacity,
      quantityInfo,
      roofDetail,
    });
  } else if (structureItem.name === "Double Carport") {
    doubleCarportPlacement({
      roofInfo,
      structureItem,
      dispatch,
      abstacles,
      gridInfo,
      limitCapacity,
      quantityInfo,
      roofDetail,
    });
  } else {
    handleSmith({
      roofInfo,
      structureItem,
      dispatch,
      abstacles,
      limitCapacity,
      quantityInfo,
      roofDetail,
      panel,
    });
  }
};
